// extracted by mini-css-extract-plugin
module.exports = {"mobileHeight":"screen and (max-height: 824px)","root":"Badge_root__2Saux","text":"Badge_text__2Nnhh","primary":"Badge_primary__2u87t"};